import { CSSProperties } from 'react';

import Card from 'components/Card/Card';

import Calendar from './components/Calendar/Calendar';

import './Classes.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
}

const Classes: React.FC<Props> = ({ style }) => {
  return (
    <div className="classes-container" style={style}>
      <Card>
        <Calendar />
      </Card>
    </div>
  );
};

export default Classes;
